/* eslint-disable @typescript-eslint/no-unused-vars */
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck
import { Box, Button } from '@mui/material';
import { useRef, useCallback, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Webcam from 'react-webcam';
import { useAppDispatch } from '../../../../store/hooks';
import { setCustomTile } from '../../../../store/tile.slice';

import './CaptureTilePhoto.styles.css';

const videoConstraints = {
  width: 720,
  height: 1280,
  facingMode: { exact: 'environment' },
};

const CapturePhoto = () => {
  const deviceHeight = document.documentElement.clientHeight;
  const deviceWidth = document.documentElement.clientWidth;
  const [fetching, setFetching] = useState(false);

  const [imageSrc, setImageSrc] = useState(null);

  const webcamRef = useRef(null);
  const dispatch = useAppDispatch();

  const capture = useCallback(() => {
    const image = webcamRef?.current?.getScreenshot();

    const img = new Image();
    // Set up the onload event for the image
    img.onload = function () {
      // Create a canvas element
      const canvas = document.createElement('canvas');
      const ctx = canvas.getContext('2d');

      // Calculate the new width and height for the compressed image
      const maxWidth = 400;
      const maxHeight = 400;
      let width = img.width;
      let height = img.height;

      if (width > height) {
        if (width > maxWidth) {
          height *= maxWidth / width;
          width = maxWidth;
        }
      } else if (height > maxHeight) {
        width *= maxHeight / height;
        height = maxHeight;
      }

      // Set the canvas dimensions to the new image dimensions
      canvas.width = width;
      canvas.height = height;

      // Draw the image on the canvas
      ctx.drawImage(img, 0, 0, width, height);

      // Get the base64 data URL of the compressed image
      const compressedDataUrl = canvas.toDataURL('image/jpeg', 0.7);
      setImageSrc(compressedDataUrl);
    };

    // Set the source of the image with the file data
    img.src = image;
  }, [webcamRef]);

  const navigate = useNavigate();

  const download = (url, name) => {
    if (!url) {
      throw new Error('Resource URL not provided! You need to provide one');
    }

    dispatch(setCustomTile(url));
    navigate('../visualizer/edit-tile', { captureImage: url });

    setFetching(true);
    fetch(url)
      .then((response) => response.blob())
      .then((blob) => {
        setFetching(false);
        const blobURL = URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = blobURL;
        a.style = 'display: none';
        if (name?.length) {
          a.download = name;
        }
        document.body.appendChild(a);
        a.click();
        navigate('../visualizer/edit-tile');
      })
      .catch(() => setError(true));
  };

  return (
    <>
      {imageSrc ? (
        <Box
          style={{ backgroundColor: '#000' }}
          sx={{ width: '100%', height: deviceHeight - 100, display: 'flex', alignItems: 'center' }}
        >
          <img width="100%" src={imageSrc} alt="" />
        </Box>
      ) : (
        <Webcam
          ref={webcamRef}
          audio={false}
          height={deviceHeight - 100}
          screenshotFormat="image/jpeg"
          width={deviceWidth}
          videoConstraints={videoConstraints}
          style={{ backgroundColor: '#000' }}
          minScreenshotWidth={400}
          minScreenshotHeight={400}
        />
      )}
      <Box className="PhotoFooter" sx={{ height: 100 }}>
        {imageSrc ? (
          <Button
            className="PhotoCancelButton LinkTypeButton BlackColor"
            variant="outlined"
            onClick={() => setImageSrc(null)}
          >
            Retake
          </Button>
        ) : (
          <Button
            className="PhotoCancelButton LinkTypeButton BlackColor"
            variant="outlined"
            onClick={() => navigate('../visualizer/select-tile')}
          >
            Cancel
          </Button>
        )}
        <button
          className="CaptureIcon"
          type="button"
          aria-label="Capture photo"
          onClick={capture}
        />
        {imageSrc ? (
          <Button
            disabled={fetching}
            onClick={() => {
              download(imageSrc, 'Tile');
            }}
            className="PhotoButton LinkTypeButton BlackColor"
            variant="outlined"
          >
            Use Photo
          </Button>
        ) : (
          <div />
        )}
      </Box>
    </>
  );
};

export default CapturePhoto;
